import iconUrl from "@/assets/brand/alevo-icon.png";
import horizontalUrl from "@/assets/brand/alevo-logo-horizontal.png";
import horizontalWhiteUrl from "@/assets/brand/alevo-logo-horizontal-white.png";
import verticalUrl from "@/assets/brand/alevo-logo-vertical.png";
import verticalWhiteUrl from "@/assets/brand/alevo-logo-vertical-white.png";

export const brand = {
  name: "Alevo Systems",
  short: "ALEVO",
  wordmark: "ALEVO",
  tagline: "ELEVATE . AUTOMATE ",
  motto: "VISION | VALUES | VICTORY",
  headline: "An all-in-one ecosystem built for restaurants by restaurant professionals.",
  positioning: "Twelve modules. One ecosystem.",
  description:
    "Alevo unifies streamlined orders, Pos integrations, phone calls, SEO, marketing and much more into a single intelligent software so operators can scale without scaling chaos.",
  /** The mark on its own, for small square spots. */
  logoUrl: iconUrl,
  /** Full logos: `light` has dark text for light backgrounds, `dark` has white text. */
  logos: {
    horizontal: { light: horizontalUrl, dark: horizontalWhiteUrl },
    vertical: { light: verticalUrl, dark: verticalWhiteUrl },
  },
  website: "https://www.alevosystems.com",
  websiteLabel: "www.alevosystems.com",
  contact: {
    email: "info@alevosystems.com",
    phone: "+18133308910",
    phoneDisplay: "(813) 330-8910",
    address: "10821 Caladesi Ave, Tampa, Florida 33610",
  },
  social: {
    instagram: "https://www.instagram.com/alevosystems",
    facebook: "https://www.facebook.com/share/1E6XVoyynv/?mibextid=wwXIfr",
    linkedin: "https://www.linkedin.com/company/alevosystems",
  },
};
